import { getTaxFullUrl } from '../../../shared/utils';
import { ProData } from '../../../shared/types';

async function zipProLookup(postalCode: string, baseURL = getTaxFullUrl()) {
  const url = `${baseURL}/api/pro-lookup`;

  const headers = {
    'Content-Type': 'application/json'
  };

  const body = {
    postal_code: postalCode
  };

  const response = await fetch(url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(body)
  });

  if (!response.ok) {
    throw new Error('Failed to fetch pro lookup');
  }

  const data = await response.json();

  return data[0] ?? ({} as ProData);
}

export { zipProLookup };
